// **************************************************************** //
// FLAMINGO ESTATE
// KITCHEN JOURNAL (blog, article, page)
// **************************************************************** //
// Developer:
// Zachary Beschler
// zachary@beschler.co
// **************************************************************** //

console.log('kitchenjournal');

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

function kj_format_time(input) {
	var mins = parseInt(input);
	if(!isNaN(mins) && mins > 0) {
		if(mins > 60) {
			var hrs = mins / 60;
			hrs = Math.floor(hrs);
			var output = hrs + ' ';
			output += (hrs == 1) ? 'hour' : 'hours';
			mins = Math.round(mins / 60 % 1 * 60);
			if(mins > 0) {
				output += ' ';
				output += mins + ' ';
				output += (mins == 1) ? 'minute' : 'minutes';
			}
		}
		else {
			var output = mins + ' ';
			output += (mins == 1) ? 'minute' : 'minutes';
		}
		return output;
	}
	else {
		return false;
	}
}

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //

$(document).ready(function() {
	
	
	
});

// **************************************************************** //
// **************************************************************** //
// **************************************************************** //
